import { Component, Inject, OnDestroy, OnInit, Optional } from '@angular/core';
import { ModalService } from '@app/core/services/modal.service';
import { RememberService } from '@app/core/services/remember.service';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { SrOperationResourceItem } from '@app/services/sr-operation.service';
import { SrNotCompletedNewGet, SrReportEvent, SrReportService } from '@app/services/sr-report.service';

@Component({
    selector: 'tt-sr-not-completed-new',
    templateUrl: './sr-not-completed-new.component.html',
    styleUrls: ['./sr-not-completed-new.component.css'],
    standalone: false,
})
export class SrNotCompletedNewComponent implements OnInit, OnDestroy {
    public page?: SrNotCompletedNewGet;
    public resources: SrOperationResourceItem[] = [];
    public events: SrReportEvent[] = [];
    public saving = false;
    public error = '';
    private initLoadDone = false;
    private initTimer?: ReturnType<typeof setTimeout>;

    constructor(private readonly report: SrReportService, private readonly modal: ModalService, private readonly remember: RememberService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator) {
        this.navigator = useNavigatorFor(navigator, this);
    }
    public async ngOnInit(): Promise<void> {
        this.initLoadDone = false;
        if (this.initTimer !== undefined) clearTimeout(this.initTimer);
        try {
            this.page = await this.report.getNewIncompleteReport({ resource_id: String(this.navigator?.params['resource_id'] ?? '') });
            this.resources = [];
            this.events = [];
            // The legacy guard starts after the page loads, independently of selector requests.
            this.initTimer = setTimeout(() => this.initLoadDone = true, 50);
            await Promise.all([
                this.report.getIncompleteReportResources().then(items => this.resources = items),
                this.report.getIncompleteReportEvents().then(items => this.events = items),
            ]);
        } catch (error) { this.showError(error); }
    }
    public async onEventChanged(value?: string | null): Promise<void> {
        if (!this.page) return;
        const oldValue = this.page.special_event_id;
        this.page.special_event_id = value;
        if (!this.initLoadDone || oldValue === undefined || value === undefined || value === null || oldValue === value) return;
        try { await this.remember.remember('w_srnotcompletednew.special_event_id', value); } catch (error) { this.showError(error); }
    }
    public async save(): Promise<void> {
        if (!this.page || this.saving) return;
        this.saving = true;
        this.error = '';
        try {
            const response = await this.report.saveIncompleteReport(this.page);
            if (response.errorcode !== '0') await this.modal.show({ type: 'warning', title: 'Varsel', message: response.errormessage,
                buttons: [{ label: 'OK', cssClass: 'btn-warning', close: true }] });
            else this.navigator?.back();
        } catch (error) { this.showError(error); }
        finally { this.saving = false; }
    }
    public ngOnDestroy(): void { if (this.initTimer !== undefined) clearTimeout(this.initTimer); }
    private showError(error: unknown): void { this.error = error instanceof Error ? error.message : String(error); }
}
